import { useState, useEffect, useRef } from "react";
import DoctorHeader from "../docnavbar/DoctorHeader";
import DoctorSidebar from "../doctorsidebar/DoctorSidebar";
import "../../../assets/css/doctor/doctorlayouts/DoctorMasterLayout.css";

const MOBILE_BREAKPOINT = 768;

const isMobileScreen = () => window.innerWidth <= MOBILE_BREAKPOINT;

const DoctorMasterLayout = ({ children }) => {
  const [isMobile, setIsMobile] = useState(isMobileScreen);
  const [sidebarOpen, setSidebarOpen] = useState(() => !isMobileScreen());
  const wasMobileRef = useRef(isMobileScreen());

  useEffect(() => {
    const handleResize = () => {
      const mobile = isMobileScreen();
      if (mobile !== wasMobileRef.current) {
        wasMobileRef.current = mobile;
        setIsMobile(mobile);
        setSidebarOpen(!mobile);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  const closeSidebarOnMobile = () => {
    if (isMobile) setSidebarOpen(false);
  };

  const sidebarWidth = isMobile ? 0 : sidebarOpen ? 250 : 80;

  return (
    <div className="master-layout">
      <div
        style={{
          width: `${sidebarWidth}px`,
          flexShrink: 0,
          transition: "width 0.3s ease",
        }}
      >
        <DoctorSidebar isOpen={sidebarOpen} onNavigate={closeSidebarOnMobile} />
      </div>

      {isMobile && sidebarOpen && (
        <div className="sidebar-backdrop" onClick={() => setSidebarOpen(false)} />
      )}

      <div className="main-content">
        <div style={{ width: "100%", flexShrink: 0 }}>
          <DoctorHeader toggleSidebar={toggleSidebar} isSidebarOpen={sidebarOpen} />
        </div>

        <div className="page-content">{children}</div>
      </div>
    </div>
  );
};

export default DoctorMasterLayout;